export const EXTERNAL_LINKS = {
  discord: "https://discord.gg/m4uHvPa4SN",
  ghInstall: "https://cli.github.com/",
  gitInstall: "https://git-scm.com/downloads",
  privacy: "https://posthog.com/privacy",
  website: "https://posthog.com/code",
} as const;
